<template>
	<div>
		<Loader :show="saving" />

		<Loader :show="loading" type="inline" />

		<FormulateForm ref="form" v-model="form" @submit="save" v-if="!loading">
			<FormulateInput
				label="Logo"
				name="logo"
				type="file"
				listStyle="thumb"
				displayBlock="true"
				validation-name="Logo de la empresa"
				validation="required"
			/>

			<FormulateInput
				label="Nombre de la cuenta"
				name="name"
				validation-name="Nombre"
				validation="required"
				class="mt-3"
			/>

			<FormulateInput
				label="Email"
				type="email"
				name="email"
				validation-name="Email"
				validation="required|email"
			/>

			<FormulateInput label="Teléfono principal" name="phone" />

			<div class="d-flex justify-content-between mt-4">
				<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader"/></FormulateInput>
				<FormulateInput type="submit" variant="primary" label="Guardar cambios" v-else />
			</div>
		</FormulateForm>
	</div>
</template>

<script>
import gql from "graphql-tag"
import mixins from "@/mixins/mixins"
import formMixins from "@/mixins/formMixins"

export default {
	name: "AccountForm",
	mixins: [mixins, formMixins],
	data() {
		return {
			loading: true,
			saving: false,
			form: {
				logo: null,
				name: null,
				email: null
			}
		}
	},
	async beforeMount() {
		await this.load()
		this.loading = false
	},
	methods: {
		save() {
			if (!this.saving) {
				this.saving = true
				let dataInput = {
					logo: this.form.logo.id || null,
					name: this.form.name,
					email: this.form.email
				}
				this.update(dataInput)
			}
		},
		update(dataInput) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: AccountInput!) {
							accountUpdate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data: dataInput
					}
				})
				.then(() => {
					this.$toast.success("Cambios guardados correctamente")
					window.location = ""
					this.saving = false
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		},
		load() {
			return this.$apollo
				.query({
					query: gql`
						query {
							account {
								name
								email
								phone
								logo {
									id
									type
									filename
									url
									urlThumb
								}
							}
						}
					`,
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.form = {
						...this.$omitDeep(data.account, "__typename")
						// category: data.part.category ? data.part.category.id : null
					}
				})
				.catch((err) => {
					this.$toast.error("Error al cargar los datos de la cuenta.")
				})
		}
	}
}
</script>

<style></style>
